import { render } from "./DeactivateModal.vue?vue&type=template&id=e2066cf4&scoped=true"
import script from "./DeactivateModal.vue?vue&type=script&lang=js"
export * from "./DeactivateModal.vue?vue&type=script&lang=js"

import "./DeactivateModal.vue?vue&type=style&index=0&id=e2066cf4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2066cf4"]])

export default __exports__